import LocalDrinkIcon from '@material-ui/icons/LocalDrink';

import SystemCreate from './create';
import SystemList from './list';
import SystemShow from './show';
import SystemEdit from './edit';

export default {
    create: SystemCreate,
    list: SystemList,
    show: SystemShow,
    edit: SystemEdit,
    icon: LocalDrinkIcon
};